import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { RecommendationUserDefinedStatus } from "src/app/models/recommendation/recommendation-user-defined-status";
import { RecommendationService } from "src/app/services/recommendation/recommendation.service";

@Injectable()
export class RecommendationUserDefinedStatusResolver  {
    
    constructor(private recommendationService: RecommendationService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<RecommendationUserDefinedStatus>> {
        const response = this.recommendationService.getRecommendationUserDefinedStatusDescription().pipe(map(response => { 
            if (response.success) {
                return response.payload;
            }
            else {
                return <RecommendationUserDefinedStatus> { description: '' };
            }
        }));
        const responsePromise = new Promise<Observable<RecommendationUserDefinedStatus>>((resolve, reject) => { resolve( response )});
        return responsePromise;
    }

}